import { render } from "./ImprimirTransferencia.vue?vue&type=template&id=4318d9bf"
import script from "./ImprimirTransferencia.vue?vue&type=script&lang=js"
export * from "./ImprimirTransferencia.vue?vue&type=script&lang=js"

import "./ImprimirTransferencia.vue?vue&type=style&index=0&id=4318d9bf&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__